(function () {
  "use strict";
  var data = {
  "manifestVersion": "1.1.0",
  "datasetId": "kj6er-pota-performer-nec4",
  "designCredit": "PERformer antenna designed by Greg Mihran, KJ6ER.",
  "nameDefinition": "PERformer means Portable, Elevated, Resonant.",
  "sourceRevision": "February 2025",
  "validation": {
    "status": "accepted",
    "reviewedBy": "Chameleon NEC-4 engineering programme",
    "reviewedAt": "2026-08-08",
    "solver": "native NEC-4.2",
    "limitations": [
      "NEC-4 simulation—not a field measurement or product specification.",
      "Absolute SS17 efficiency and realised gain remain measurement-required.",
      "The 6 m pattern shape and lobe angle are stable; absolute NEC gain remains provisional."
    ],
    "blocked": [
      "40 m pending measured or documented coil parameters",
      "absolute SS17 efficiency and realised gain pending conductor/choke measurements"
    ],
    "sourceFiles": [
      "performer_ckb_data_v1.0.0.json",
      "validation_manifest.json",
      "alt_text_and_captions.json"
    ],
    "sha256": "07fbbf0829c47c1781bfd4cf00d33076a4a0e974d1a7e20787018d8c459d43be"
  },
  "cases": [
    {
      "bandMetres": 20,
      "radialAngleDegrees": 90,
      "frequencyMHz": 14.25,
      "radiatorLengthM": 5.2578,
      "radiatorLengthIn": 207,
      "radialLengthM": 5.0291999999999994,
      "radialLengthIn": 198,
      "feedpointHeightM": 1.3208,
      "feedpointHeightIn": 52,
      "radialEndpointHeightM": 0.9144,
      "peakNecGainDbi": 1.02,
      "peakAzimuthDegrees": 45,
      "peakElevationDegrees": 26,
      "azimuthVariationDb": 3.5,
      "feedpointImpedanceOhms": "41.7 − j3.5",
      "swr50": 1.22,
      "sourceModel": "04_MODELS/CHA_POTA_PERFORMER/PPF-R002D-PAT-20260808-003-20M.nec",
      "runId": "PPF-R002D-PAT-20260808-003-20M",
      "necVersion": "4.2",
      "gainDefinition": "NEC gain with perfect conductor wires and finite-ground loss; mismatch excluded",
      "operatorMeaning": "The 90-degree span favours the radial bisector; the 180-degree span provides more balanced azimuth coverage.",
      "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
      "assets": {
        "pattern": {
          "filename": "ckb-performer_20m_90deg_nec4_pattern.svg",
          "alt": "NEC-4 elevation and azimuth patterns for the KJ6ER POTA PERformer on 20m with two elevated radials 90 degrees apart.",
          "caption": "Peak modelled lobe: +1.02 dBi at 45° azimuth / 26° elevation. Limitation: idealised constant-radius SS17 and ideal feed-line isolation; not a measured product specification.",
          "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
          "evidenceType": "NEC-4 simulation",
          "runIds": [
            "PPF-R002D-PAT-20260808-003-20M"
          ]
        }
      }
    },
    {
      "bandMetres": 20,
      "radialAngleDegrees": 180,
      "frequencyMHz": 14.25,
      "radiatorLengthM": 5.2578,
      "radiatorLengthIn": 207,
      "radialLengthM": 5.0291999999999994,
      "radialLengthIn": 198,
      "feedpointHeightM": 1.3208,
      "feedpointHeightIn": 52,
      "radialEndpointHeightM": 0.9144,
      "peakNecGainDbi": 0.11,
      "peakAzimuthDegrees": 90,
      "peakElevationDegrees": 24,
      "azimuthVariationDb": 0.25,
      "feedpointImpedanceOhms": "37.1 − j10.2",
      "swr50": 1.46,
      "sourceModel": "04_MODELS/CHA_POTA_PERFORMER/PPF-R002O-PAT-20260808-003-20M.nec",
      "runId": "PPF-R002O-PAT-20260808-003-20M",
      "necVersion": "4.2",
      "gainDefinition": "NEC gain with perfect conductor wires and finite-ground loss; mismatch excluded",
      "operatorMeaning": "The 90-degree span favours the radial bisector; the 180-degree span provides more balanced azimuth coverage.",
      "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
      "assets": {
        "pattern": {
          "filename": "ckb-performer_20m_180deg_nec4_pattern.svg",
          "alt": "NEC-4 elevation and azimuth patterns for the KJ6ER POTA PERformer on 20m with two elevated radials 180 degrees apart.",
          "caption": "Peak modelled lobe: +0.11 dBi at 90° azimuth / 24° elevation. Limitation: idealised constant-radius SS17 and ideal feed-line isolation; not a measured product specification.",
          "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
          "evidenceType": "NEC-4 simulation",
          "runIds": [
            "PPF-R002O-PAT-20260808-003-20M"
          ]
        }
      }
    },
    {
      "bandMetres": 17,
      "radialAngleDegrees": 90,
      "frequencyMHz": 18.14,
      "radiatorLengthM": 4.191,
      "radiatorLengthIn": 165,
      "radialLengthM": 3.7845999999999997,
      "radialLengthIn": 149,
      "feedpointHeightM": 1.3208,
      "feedpointHeightIn": 52,
      "radialEndpointHeightM": 0.9144,
      "peakNecGainDbi": 1.2,
      "peakAzimuthDegrees": 40,
      "peakElevationDegrees": 25,
      "azimuthVariationDb": 3.2299999999999995,
      "feedpointImpedanceOhms": "41.2 − j8.8",
      "swr50": 1.31,
      "sourceModel": "04_MODELS/CHA_POTA_PERFORMER/PPF-R002D-PAT-20260808-003-17M.nec",
      "runId": "PPF-R002D-PAT-20260808-003-17M",
      "necVersion": "4.2",
      "gainDefinition": "NEC gain with perfect conductor wires and finite-ground loss; mismatch excluded",
      "operatorMeaning": "The 90-degree span favours the radial bisector; the 180-degree span provides more balanced azimuth coverage.",
      "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
      "assets": {
        "pattern": {
          "filename": "ckb-performer_17m_90deg_nec4_pattern.svg",
          "alt": "NEC-4 elevation and azimuth patterns for the KJ6ER POTA PERformer on 17m with two elevated radials 90 degrees apart.",
          "caption": "Peak modelled lobe: +1.20 dBi at 40° azimuth / 25° elevation. Limitation: idealised constant-radius SS17 and ideal feed-line isolation; not a measured product specification.",
          "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
          "evidenceType": "NEC-4 simulation",
          "runIds": [
            "PPF-R002D-PAT-20260808-003-17M"
          ]
        }
      }
    },
    {
      "bandMetres": 17,
      "radialAngleDegrees": 180,
      "frequencyMHz": 18.14,
      "radiatorLengthM": 4.191,
      "radiatorLengthIn": 165,
      "radialLengthM": 3.7845999999999997,
      "radialLengthIn": 149,
      "feedpointHeightM": 1.3208,
      "feedpointHeightIn": 52,
      "radialEndpointHeightM": 0.9144,
      "peakNecGainDbi": 0.33,
      "peakAzimuthDegrees": 80,
      "peakElevationDegrees": 23,
      "azimuthVariationDb": 0.2,
      "feedpointImpedanceOhms": "37.0 − j15.8",
      "swr50": 1.6,
      "sourceModel": "04_MODELS/CHA_POTA_PERFORMER/PPF-R002O-PAT-20260808-003-17M.nec",
      "runId": "PPF-R002O-PAT-20260808-003-17M",
      "necVersion": "4.2",
      "gainDefinition": "NEC gain with perfect conductor wires and finite-ground loss; mismatch excluded",
      "operatorMeaning": "The 90-degree span favours the radial bisector; the 180-degree span provides more balanced azimuth coverage.",
      "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
      "assets": {
        "pattern": {
          "filename": "ckb-performer_17m_180deg_nec4_pattern.svg",
          "alt": "NEC-4 elevation and azimuth patterns for the KJ6ER POTA PERformer on 17m with two elevated radials 180 degrees apart.",
          "caption": "Peak modelled lobe: +0.33 dBi at 80° azimuth / 23° elevation. Limitation: idealised constant-radius SS17 and ideal feed-line isolation; not a measured product specification.",
          "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
          "evidenceType": "NEC-4 simulation",
          "runIds": [
            "PPF-R002O-PAT-20260808-003-17M"
          ]
        }
      }
    },
    {
      "bandMetres": 15,
      "radialAngleDegrees": 90,
      "frequencyMHz": 21.35,
      "radiatorLengthM": 3.6576,
      "radiatorLengthIn": 144,
      "radialLengthM": 3.048,
      "radialLengthIn": 120,
      "feedpointHeightM": 1.3208,
      "feedpointHeightIn": 52,
      "radialEndpointHeightM": 0.9144,
      "peakNecGainDbi": 1.31,
      "peakAzimuthDegrees": 40,
      "peakElevationDegrees": 24,
      "azimuthVariationDb": 2.88,
      "feedpointImpedanceOhms": "42.5 − j9.6",
      "swr50": 1.3,
      "sourceModel": "04_MODELS/CHA_POTA_PERFORMER/PPF-R002D-PAT-20260808-003-15M.nec",
      "runId": "PPF-R002D-PAT-20260808-003-15M",
      "necVersion": "4.2",
      "gainDefinition": "NEC gain with perfect conductor wires and finite-ground loss; mismatch excluded",
      "operatorMeaning": "The 90-degree span favours the radial bisector; the 180-degree span provides more balanced azimuth coverage.",
      "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
      "assets": {
        "pattern": {
          "filename": "ckb-performer_15m_90deg_nec4_pattern.svg",
          "alt": "NEC-4 elevation and azimuth patterns for the KJ6ER POTA PERformer on 15m with two elevated radials 90 degrees apart.",
          "caption": "Peak modelled lobe: +1.31 dBi at 40° azimuth / 24° elevation. Limitation: idealised constant-radius SS17 and ideal feed-line isolation; not a measured product specification.",
          "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
          "evidenceType": "NEC-4 simulation",
          "runIds": [
            "PPF-R002D-PAT-20260808-003-15M"
          ]
        }
      }
    },
    {
      "bandMetres": 15,
      "radialAngleDegrees": 180,
      "frequencyMHz": 21.35,
      "radiatorLengthM": 3.6576,
      "radiatorLengthIn": 144,
      "radialLengthM": 3.048,
      "radialLengthIn": 120,
      "feedpointHeightM": 1.3208,
      "feedpointHeightIn": 52,
      "radialEndpointHeightM": 0.9144,
      "peakNecGainDbi": 0.5,
      "peakAzimuthDegrees": 85,
      "peakElevationDegrees": 23,
      "azimuthVariationDb": 0.18,
      "feedpointImpedanceOhms": "38.6 − j16.5",
      "swr50": 1.57,
      "sourceModel": "04_MODELS/CHA_POTA_PERFORMER/PPF-R002O-PAT-20260808-003-15M.nec",
      "runId": "PPF-R002O-PAT-20260808-003-15M",
      "necVersion": "4.2",
      "gainDefinition": "NEC gain with perfect conductor wires and finite-ground loss; mismatch excluded",
      "operatorMeaning": "The 90-degree span favours the radial bisector; the 180-degree span provides more balanced azimuth coverage.",
      "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
      "assets": {
        "pattern": {
          "filename": "ckb-performer_15m_180deg_nec4_pattern.svg",
          "alt": "NEC-4 elevation and azimuth patterns for the KJ6ER POTA PERformer on 15m with two elevated radials 180 degrees apart.",
          "caption": "Peak modelled lobe: +0.50 dBi at 85° azimuth / 23° elevation. Limitation: idealised constant-radius SS17 and ideal feed-line isolation; not a measured product specification.",
          "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
          "evidenceType": "NEC-4 simulation",
          "runIds": [
            "PPF-R002O-PAT-20260808-003-15M"
          ]
        }
      }
    },
    {
      "bandMetres": 12,
      "radialAngleDegrees": 90,
      "frequencyMHz": 24.94,
      "radiatorLengthM": 3.2003999999999997,
      "radiatorLengthIn": 126,
      "radialLengthM": 2.4383999999999997,
      "radialLengthIn": 96,
      "feedpointHeightM": 1.3208,
      "feedpointHeightIn": 52,
      "radialEndpointHeightM": 0.9144,
      "peakNecGainDbi": 1.42,
      "peakAzimuthDegrees": 45,
      "peakElevationDegrees": 23,
      "azimuthVariationDb": 2.5300000000000002,
      "feedpointImpedanceOhms": "43.2 − j16.4",
      "swr50": 1.46,
      "sourceModel": "04_MODELS/CHA_POTA_PERFORMER/PPF-R002D-PAT-20260808-003-12M.nec",
      "runId": "PPF-R002D-PAT-20260808-003-12M",
      "necVersion": "4.2",
      "gainDefinition": "NEC gain with perfect conductor wires and finite-ground loss; mismatch excluded",
      "operatorMeaning": "The 90-degree span favours the radial bisector; the 180-degree span provides more balanced azimuth coverage.",
      "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
      "assets": {
        "pattern": {
          "filename": "ckb-performer_12m_90deg_nec4_pattern.svg",
          "alt": "NEC-4 elevation and azimuth patterns for the KJ6ER POTA PERformer on 12m with two elevated radials 90 degrees apart.",
          "caption": "Peak modelled lobe: +1.42 dBi at 45° azimuth / 23° elevation. Limitation: idealised constant-radius SS17 and ideal feed-line isolation; not a measured product specification.",
          "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
          "evidenceType": "NEC-4 simulation",
          "runIds": [
            "PPF-R002D-PAT-20260808-003-12M"
          ]
        }
      }
    },
    {
      "bandMetres": 12,
      "radialAngleDegrees": 180,
      "frequencyMHz": 24.94,
      "radiatorLengthM": 3.2003999999999997,
      "radiatorLengthIn": 126,
      "radialLengthM": 2.4383999999999997,
      "radialLengthIn": 96,
      "feedpointHeightM": 1.3208,
      "feedpointHeightIn": 52,
      "radialEndpointHeightM": 0.9144,
      "peakNecGainDbi": 0.67,
      "peakAzimuthDegrees": 90,
      "peakElevationDegrees": 22,
      "azimuthVariationDb": 0.15000000000000002,
      "feedpointImpedanceOhms": "39.8 − j23.0",
      "swr50": 1.75,
      "sourceModel": "04_MODELS/CHA_POTA_PERFORMER/PPF-R002O-PAT-20260808-003-12M.nec",
      "runId": "PPF-R002O-PAT-20260808-003-12M",
      "necVersion": "4.2",
      "gainDefinition": "NEC gain with perfect conductor wires and finite-ground loss; mismatch excluded",
      "operatorMeaning": "The 90-degree span favours the radial bisector; the 180-degree span provides more balanced azimuth coverage.",
      "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
      "assets": {
        "pattern": {
          "filename": "ckb-performer_12m_180deg_nec4_pattern.svg",
          "alt": "NEC-4 elevation and azimuth patterns for the KJ6ER POTA PERformer on 12m with two elevated radials 180 degrees apart.",
          "caption": "Peak modelled lobe: +0.67 dBi at 90° azimuth / 22° elevation. Limitation: idealised constant-radius SS17 and ideal feed-line isolation; not a measured product specification.",
          "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
          "evidenceType": "NEC-4 simulation",
          "runIds": [
            "PPF-R002O-PAT-20260808-003-12M"
          ]
        }
      }
    },
    {
      "bandMetres": 10,
      "radialAngleDegrees": 90,
      "frequencyMHz": 28.4,
      "radiatorLengthM": 2.8702,
      "radiatorLengthIn": 113,
      "radialLengthM": 2.032,
      "radialLengthIn": 80,
      "feedpointHeightM": 1.3208,
      "feedpointHeightIn": 52,
      "radialEndpointHeightM": 0.9144,
      "peakNecGainDbi": 1.52,
      "peakAzimuthDegrees": 40,
      "peakElevationDegrees": 23,
      "azimuthVariationDb": 2.33,
      "feedpointImpedanceOhms": "44.2 − j18.5",
      "swr50": 1.51,
      "sourceModel": "04_MODELS/CHA_POTA_PERFORMER/PPF-R002D-PAT-20260808-003-10M.nec",
      "runId": "PPF-R002D-PAT-20260808-003-10M",
      "necVersion": "4.2",
      "gainDefinition": "NEC gain with perfect conductor wires and finite-ground loss; mismatch excluded",
      "operatorMeaning": "The 90-degree span favours the radial bisector; the 180-degree span provides more balanced azimuth coverage.",
      "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
      "assets": {
        "pattern": {
          "filename": "ckb-performer_10m_90deg_nec4_pattern.svg",
          "alt": "NEC-4 elevation and azimuth patterns for the KJ6ER POTA PERformer on 10m with two elevated radials 90 degrees apart.",
          "caption": "Peak modelled lobe: +1.52 dBi at 40° azimuth / 23° elevation. Limitation: idealised constant-radius SS17 and ideal feed-line isolation; not a measured product specification.",
          "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
          "evidenceType": "NEC-4 simulation",
          "runIds": [
            "PPF-R002D-PAT-20260808-003-10M"
          ]
        }
      }
    },
    {
      "bandMetres": 10,
      "radialAngleDegrees": 180,
      "frequencyMHz": 28.4,
      "radiatorLengthM": 2.8702,
      "radiatorLengthIn": 113,
      "radialLengthM": 2.032,
      "radialLengthIn": 80,
      "feedpointHeightM": 1.3208,
      "feedpointHeightIn": 52,
      "radialEndpointHeightM": 0.9144,
      "peakNecGainDbi": 0.82,
      "peakAzimuthDegrees": 80,
      "peakElevationDegrees": 21,
      "azimuthVariationDb": 0.12,
      "feedpointImpedanceOhms": "41.2 − j24.8",
      "swr50": 1.77,
      "sourceModel": "04_MODELS/CHA_POTA_PERFORMER/PPF-R002O-PAT-20260808-003-10M.nec",
      "runId": "PPF-R002O-PAT-20260808-003-10M",
      "necVersion": "4.2",
      "gainDefinition": "NEC gain with perfect conductor wires and finite-ground loss; mismatch excluded",
      "operatorMeaning": "The 90-degree span favours the radial bisector; the 180-degree span provides more balanced azimuth coverage.",
      "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
      "assets": {
        "pattern": {
          "filename": "ckb-performer_10m_180deg_nec4_pattern.svg",
          "alt": "NEC-4 elevation and azimuth patterns for the KJ6ER POTA PERformer on 10m with two elevated radials 180 degrees apart.",
          "caption": "Peak modelled lobe: +0.82 dBi at 80° azimuth / 21° elevation. Limitation: idealised constant-radius SS17 and ideal feed-line isolation; not a measured product specification.",
          "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
          "evidenceType": "NEC-4 simulation",
          "runIds": [
            "PPF-R002O-PAT-20260808-003-10M"
          ]
        }
      }
    },
    {
      "bandMetres": 6,
      "radialAngleDegrees": 90,
      "frequencyMHz": 51,
      "radiatorLengthM": 1.6256,
      "radiatorLengthIn": 64,
      "radialLengthM": 1.0922,
      "radialLengthIn": 43,
      "feedpointHeightM": 1.3208,
      "feedpointHeightIn": 52,
      "radialEndpointHeightM": 0.9144,
      "peakNecGainDbi": 2.25,
      "peakAzimuthDegrees": 40,
      "peakElevationDegrees": 19,
      "azimuthVariationDb": 1.8900000000000001,
      "feedpointImpedanceOhms": "42.9 − j10.6",
      "swr50": 1.32,
      "sourceModel": "04_MODELS/CHA_POTA_PERFORMER/PPF-R002D-PAT-20260808-003-6M.nec",
      "runId": "PPF-R002D-PAT-20260808-003-6M",
      "necVersion": "4.2",
      "gainDefinition": "NEC gain with perfect conductor wires and finite-ground loss; mismatch excluded",
      "operatorMeaning": "The 90-degree span favours the radial bisector; the 180-degree span provides more balanced azimuth coverage.",
      "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification. Absolute gain is numerically provisional on 6 m.",
      "assets": {
        "pattern": {
          "filename": "ckb-performer_6m_90deg_nec4_pattern.svg",
          "alt": "NEC-4 elevation and azimuth patterns for the KJ6ER POTA PERformer on 6m with two elevated radials 90 degrees apart.",
          "caption": "Peak modelled lobe: +2.25 dBi at 40° azimuth / 19° elevation. Limitation: idealised constant-radius SS17 and ideal feed-line isolation; not a measured product specification.",
          "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
          "evidenceType": "NEC-4 simulation",
          "runIds": [
            "PPF-R002D-PAT-20260808-003-6M"
          ]
        }
      }
    },
    {
      "bandMetres": 6,
      "radialAngleDegrees": 180,
      "frequencyMHz": 51,
      "radiatorLengthM": 1.6256,
      "radiatorLengthIn": 64,
      "radialLengthM": 1.0922,
      "radialLengthIn": 43,
      "feedpointHeightM": 1.3208,
      "feedpointHeightIn": 52,
      "radialEndpointHeightM": 0.9144,
      "peakNecGainDbi": 1.71,
      "peakAzimuthDegrees": 85,
      "peakElevationDegrees": 18,
      "azimuthVariationDb": 0.11999999999999988,
      "feedpointImpedanceOhms": "40.0 − j16.3",
      "swr50": 1.53,
      "sourceModel": "04_MODELS/CHA_POTA_PERFORMER/PPF-R002O-PAT-20260808-003-6M.nec",
      "runId": "PPF-R002O-PAT-20260808-003-6M",
      "necVersion": "4.2",
      "gainDefinition": "NEC gain with perfect conductor wires and finite-ground loss; mismatch excluded",
      "operatorMeaning": "The 90-degree span favours the radial bisector; the 180-degree span provides more balanced azimuth coverage.",
      "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification. Absolute gain is numerically provisional on 6 m.",
      "assets": {
        "pattern": {
          "filename": "ckb-performer_6m_180deg_nec4_pattern.svg",
          "alt": "NEC-4 elevation and azimuth patterns for the KJ6ER POTA PERformer on 6m with two elevated radials 180 degrees apart.",
          "caption": "Peak modelled lobe: +1.71 dBi at 85° azimuth / 18° elevation. Limitation: idealised constant-radius SS17 and ideal feed-line isolation; not a measured product specification.",
          "limitation": "Idealised constant-radius perfect-conductor SS17 and ideal feed-line isolation; not a measured product specification.",
          "evidenceType": "NEC-4 simulation",
          "runIds": [
            "PPF-R002O-PAT-20260808-003-6M"
          ]
        }
      }
    }
  ],
  "bands": [
    {
      "bandMetres": 20,
      "comparison": {
        "filename": "ckb-performer_20m_90_vs_180_nec4.svg",
        "alt": "NEC-4 comparison of 90-degree and 180-degree radial arrangements for the KJ6ER POTA PERformer on 20m.",
        "caption": "The two arrangements use the same band dimensions; only radial bearing changes. Limitation: idealised NEC-4 geometry, not a field guarantee.",
        "limitation": "Idealised conductor and feed-line isolation; installation-dependent.",
        "evidenceType": "Controlled model comparison",
        "runIds": [
          "PPF-R002D-PAT-20260808-003-20M",
          "PPF-R002O-PAT-20260808-003-20M"
        ]
      },
      "currentDistribution": {
        "filename": "ckb-performer_20m_current_distribution_nec4.svg",
        "alt": "Normalised NEC-4 current magnitude along the radiator and two active radials of the KJ6ER POTA PERformer on 20m, comparing 90-degree and 180-degree radial spans.",
        "caption": "The active radiator and both tuned radials carry RF current. Limitation: normalised ideal-conductor model.",
        "limitation": "Normalised ideal-conductor current; not measured.",
        "evidenceType": "NEC-4 simulation",
        "runIds": [
          "PPF-R002D-PAT-20260808-003-20M",
          "PPF-R002O-PAT-20260808-003-20M"
        ]
      },
      "controlledRybakovComparison": {
        "filename": "ckb-performer_vs_rybakov_20m_controlled_nec4.svg",
        "alt": "Controlled NEC-4 elevation-pattern comparison of the KJ6ER POTA PERformer and documented Chameleon Rybakov reference on 20m.",
        "caption": "Common modelling environment; native antenna geometries retained. Network loss and real-conductor loss are unresolved.",
        "limitation": "Ideal conductors; transformer, tuner and choke loss excluded.",
        "evidenceType": "Controlled model comparison",
        "runIds": [
          "PPF-R002D-PAT-20260808-003-20M",
          "PPF-R002O-PAT-20260808-003-20M",
          "PPF-R006-CMP-20260808-001-RYB-20M"
        ]
      }
    },
    {
      "bandMetres": 17,
      "comparison": {
        "filename": "ckb-performer_17m_90_vs_180_nec4.svg",
        "alt": "NEC-4 comparison of 90-degree and 180-degree radial arrangements for the KJ6ER POTA PERformer on 17m.",
        "caption": "The two arrangements use the same band dimensions; only radial bearing changes. Limitation: idealised NEC-4 geometry, not a field guarantee.",
        "limitation": "Idealised conductor and feed-line isolation; installation-dependent.",
        "evidenceType": "Controlled model comparison",
        "runIds": [
          "PPF-R002D-PAT-20260808-003-17M",
          "PPF-R002O-PAT-20260808-003-17M"
        ]
      },
      "currentDistribution": {
        "filename": "ckb-performer_17m_current_distribution_nec4.svg",
        "alt": "Normalised NEC-4 current magnitude along the radiator and two active radials of the KJ6ER POTA PERformer on 17m, comparing 90-degree and 180-degree radial spans.",
        "caption": "The active radiator and both tuned radials carry RF current. Limitation: normalised ideal-conductor model.",
        "limitation": "Normalised ideal-conductor current; not measured.",
        "evidenceType": "NEC-4 simulation",
        "runIds": [
          "PPF-R002D-PAT-20260808-003-17M",
          "PPF-R002O-PAT-20260808-003-17M"
        ]
      },
      "controlledRybakovComparison": null
    },
    {
      "bandMetres": 15,
      "comparison": {
        "filename": "ckb-performer_15m_90_vs_180_nec4.svg",
        "alt": "NEC-4 comparison of 90-degree and 180-degree radial arrangements for the KJ6ER POTA PERformer on 15m.",
        "caption": "The two arrangements use the same band dimensions; only radial bearing changes. Limitation: idealised NEC-4 geometry, not a field guarantee.",
        "limitation": "Idealised conductor and feed-line isolation; installation-dependent.",
        "evidenceType": "Controlled model comparison",
        "runIds": [
          "PPF-R002D-PAT-20260808-003-15M",
          "PPF-R002O-PAT-20260808-003-15M"
        ]
      },
      "currentDistribution": {
        "filename": "ckb-performer_15m_current_distribution_nec4.svg",
        "alt": "Normalised NEC-4 current magnitude along the radiator and two active radials of the KJ6ER POTA PERformer on 15m, comparing 90-degree and 180-degree radial spans.",
        "caption": "The active radiator and both tuned radials carry RF current. Limitation: normalised ideal-conductor model.",
        "limitation": "Normalised ideal-conductor current; not measured.",
        "evidenceType": "NEC-4 simulation",
        "runIds": [
          "PPF-R002D-PAT-20260808-003-15M",
          "PPF-R002O-PAT-20260808-003-15M"
        ]
      },
      "controlledRybakovComparison": {
        "filename": "ckb-performer_vs_rybakov_15m_controlled_nec4.svg",
        "alt": "Controlled NEC-4 elevation-pattern comparison of the KJ6ER POTA PERformer and documented Chameleon Rybakov reference on 15m.",
        "caption": "Common modelling environment; native antenna geometries retained. Network loss and real-conductor loss are unresolved.",
        "limitation": "Ideal conductors; transformer, tuner and choke loss excluded.",
        "evidenceType": "Controlled model comparison",
        "runIds": [
          "PPF-R002D-PAT-20260808-003-15M",
          "PPF-R002O-PAT-20260808-003-15M",
          "PPF-R006-CMP-20260808-001-RYB-15M"
        ]
      }
    },
    {
      "bandMetres": 12,
      "comparison": {
        "filename": "ckb-performer_12m_90_vs_180_nec4.svg",
        "alt": "NEC-4 comparison of 90-degree and 180-degree radial arrangements for the KJ6ER POTA PERformer on 12m.",
        "caption": "The two arrangements use the same band dimensions; only radial bearing changes. Limitation: idealised NEC-4 geometry, not a field guarantee.",
        "limitation": "Idealised conductor and feed-line isolation; installation-dependent.",
        "evidenceType": "Controlled model comparison",
        "runIds": [
          "PPF-R002D-PAT-20260808-003-12M",
          "PPF-R002O-PAT-20260808-003-12M"
        ]
      },
      "currentDistribution": {
        "filename": "ckb-performer_12m_current_distribution_nec4.svg",
        "alt": "Normalised NEC-4 current magnitude along the radiator and two active radials of the KJ6ER POTA PERformer on 12m, comparing 90-degree and 180-degree radial spans.",
        "caption": "The active radiator and both tuned radials carry RF current. Limitation: normalised ideal-conductor model.",
        "limitation": "Normalised ideal-conductor current; not measured.",
        "evidenceType": "NEC-4 simulation",
        "runIds": [
          "PPF-R002D-PAT-20260808-003-12M",
          "PPF-R002O-PAT-20260808-003-12M"
        ]
      },
      "controlledRybakovComparison": null
    },
    {
      "bandMetres": 10,
      "comparison": {
        "filename": "ckb-performer_10m_90_vs_180_nec4.svg",
        "alt": "NEC-4 comparison of 90-degree and 180-degree radial arrangements for the KJ6ER POTA PERformer on 10m.",
        "caption": "The two arrangements use the same band dimensions; only radial bearing changes. Limitation: idealised NEC-4 geometry, not a field guarantee.",
        "limitation": "Idealised conductor and feed-line isolation; installation-dependent.",
        "evidenceType": "Controlled model comparison",
        "runIds": [
          "PPF-R002D-PAT-20260808-003-10M",
          "PPF-R002O-PAT-20260808-003-10M"
        ]
      },
      "currentDistribution": {
        "filename": "ckb-performer_10m_current_distribution_nec4.svg",
        "alt": "Normalised NEC-4 current magnitude along the radiator and two active radials of the KJ6ER POTA PERformer on 10m, comparing 90-degree and 180-degree radial spans.",
        "caption": "The active radiator and both tuned radials carry RF current. Limitation: normalised ideal-conductor model.",
        "limitation": "Normalised ideal-conductor current; not measured.",
        "evidenceType": "NEC-4 simulation",
        "runIds": [
          "PPF-R002D-PAT-20260808-003-10M",
          "PPF-R002O-PAT-20260808-003-10M"
        ]
      },
      "controlledRybakovComparison": {
        "filename": "ckb-performer_vs_rybakov_10m_controlled_nec4.svg",
        "alt": "Controlled NEC-4 elevation-pattern comparison of the KJ6ER POTA PERformer and documented Chameleon Rybakov reference on 10m.",
        "caption": "Common modelling environment; native antenna geometries retained. Network loss and real-conductor loss are unresolved.",
        "limitation": "Ideal conductors; transformer, tuner and choke loss excluded.",
        "evidenceType": "Controlled model comparison",
        "runIds": [
          "PPF-R002D-PAT-20260808-003-10M",
          "PPF-R002O-PAT-20260808-003-10M",
          "PPF-R006-CMP-20260808-001-RYB-10M"
        ]
      }
    },
    {
      "bandMetres": 6,
      "comparison": {
        "filename": "ckb-performer_6m_90_vs_180_nec4.svg",
        "alt": "NEC-4 comparison of 90-degree and 180-degree radial arrangements for the KJ6ER POTA PERformer on 6m.",
        "caption": "The two arrangements use the same band dimensions; only radial bearing changes. Limitation: idealised NEC-4 geometry, not a field guarantee.",
        "limitation": "Idealised conductor and feed-line isolation; installation-dependent.",
        "evidenceType": "Controlled model comparison",
        "runIds": [
          "PPF-R002D-PAT-20260808-003-6M",
          "PPF-R002O-PAT-20260808-003-6M"
        ]
      },
      "currentDistribution": {
        "filename": "ckb-performer_6m_current_distribution_nec4.svg",
        "alt": "Normalised NEC-4 current magnitude along the radiator and two active radials of the KJ6ER POTA PERformer on 6m, comparing 90-degree and 180-degree radial spans.",
        "caption": "The active radiator and both tuned radials carry RF current. Limitation: normalised ideal-conductor model.",
        "limitation": "Normalised ideal-conductor current; not measured.",
        "evidenceType": "NEC-4 simulation",
        "runIds": [
          "PPF-R002D-PAT-20260808-003-6M",
          "PPF-R002O-PAT-20260808-003-6M"
        ]
      },
      "controlledRybakovComparison": null
    }
  ]
};
  var base = document.currentScript && document.currentScript.src ? document.currentScript.src : window.location.href;
  var resolveAsset = function (asset) { if (asset && asset.filename) asset.url = new URL(asset.filename, base).href; };
  data.cases.forEach(function (item) { resolveAsset(item.assets.pattern); });
  data.bands.forEach(function (item) { resolveAsset(item.comparison); resolveAsset(item.currentDistribution); resolveAsset(item.controlledRybakovComparison); });
  window.CHA_PERFORMER_NEC_DATA = data;
})();
